const PATH = 'fe.components.reliability_test';

const messages = {
  dimensionScore: {
    key: `${PATH}.dimension_score`,
    defaultValue: 'Dimension score {{value}}'
  },
  logoDescription: {
    key: `${PATH}.logo_description`,
    defaultValue: 'Certification Logo'
  },
  subtitle: {
    key: `${PATH}.subtitle`,
    defaultValue: 'Watch and code each testing video'
  },
  attempt: {
    key: `${PATH}.attempt`,
    defaultValue: 'Attempt {{value}}'
  },
  expiresOn: {
    key: `${PATH}.expires_on`,
    defaultValue: 'Expires on:'
  },
  expiresOnMobile: {
    key: `${PATH}.expires_on_mobile`,
    defaultValue: 'Exp.'
  },
  testInstructions: {
    key: `${PATH}.test_instructions`,
    defaultValue: 'View Test Instructions'
  },
  testPrepResources: {
    key: `${PATH}.test_prep_resources`,
    defaultValue: 'View test preparation resources'
  },
  modal: {
    instructionsTitle: {
      key: `${PATH}.modal.instructions_title`,
      defaultValue: 'Instructions'
    },
    dismissButton: {
      key: `${PATH}.modal.dismiss_button`,
      defaultValue: 'Dismiss'
    }
  },
  chart: {
    title: {
      key: `${PATH}.chart.title`,
      defaultValue: 'CLASS Score Report: Graphical Representation of Score'
    }
  },
  confirmationModal: {
    title: {
      key: `${PATH}.confirmation_modal.title`,
      defaultValue: `Are you sure you're ready to submit?`
    },
    submit: {
      key: `${PATH}.confirmation_modal.submit`,
      defaultValue: `Submit`
    },
    cancel: {
      key: `${PATH}.confirmation_modal.review_codes`,
      defaultValue: `Review codes`
    }
  },
  incompleteDimensionsError: {
    key: `${PATH}.incomplete_dimensions_error`,
    defaultValue: 'Please enter all dimension codes'
  },
  dimensionCodeError: {
    key: `${PATH}.dimension_code_error`,
    defaultValue: 'Please enter a code for {{name}} ({{abbreviation}}).'
  },
  missingDimensionsError: {
    key: `${PATH}.missing_dimensions_error`,
    defaultValue: 'Please enter all dimension codes. Missing: {{dimensions}}.'
  },
  notes: {
    key: `${PATH}.notes`,
    defaultValue: 'Notes'
  },
  practiceVideos: {
    key: `${PATH}.practice_videos`,
    defaultValue: 'Access Practice Videos & Test Prep'
  },
  error: {
    key: `${PATH}.error`,
    defaultValue: 'An error occurred. Please contact support.'
  }
};

export default messages;
